export const TRINIO_CONFIG = {
    merchantId: '01GYZF2Z6MSWVYHFWP0P98VNFJ',
    cssHref: 'https://cdn.trinio.co/static/css/style.css',
    scriptHref:
        'https://cdn.trinio.co/static/plugin-vtex-sdk/latest/trinio-plugin-vtex-sdk.iife.js',
    vtexAccountName: 'torratorra',
    vtexEndpointAPI: 'https://www.lojastorra.com.br/api/vtexid',
    vtexPublicEndpoint: 'myvtex.com',
    vtexWorkspace: 'master',
    fallbackHref: '/checkout',
} as const
